import type {
  FullPublicProfileProductFragment,
  GetOrderQuery,
  PublicOrderItem,
} from 'apollo-gql'
import { pushToDataLayer } from 'lib/tracking'

// TODO: Replace EComerceItem when `next lint` doesn't throw a prettier error for
// template literals in types
// type EComerceItem = PublicOrderItem & {
//   [key: `addonProduct${number}Type`]: ProductType
//   [key: `addonProduct${number}Price`]: number
// }

interface ECommerceItem {
  [key: string]: unknown
}

interface ECommerceProductReturn {
  id: string
  name: string
  price: number
  category: string
}

export const getEcommerceProducts = (
  items: GetOrderQuery['market']['order']['items'],
): ECommerceProductReturn[] => {
  return items?.map((item: PublicOrderItem) => {
    return {
      id: item.profileProduct?.id,
      name: `${item.videoRequest?.publicProfile?.slug}-${item.productType}`,
      price: item.totalPriceIncVat.valueWithDecimals,
      priceExVat: item.totalPriceExVat.valueWithDecimals,
      priceExAddons: item.priceIncVat?.valueWithDecimals,
      priceExAddonsAndVat: item.priceExVat?.valueWithDecimals,
      category: item.profileProduct.product.slug,
      ...item.orderItemChildren.reduce(
        (aPayload: PublicOrderItem, b: PublicOrderItem, i: number) => {
          const a: ECommerceItem = aPayload
          a[`addonProduct${i + 1}Type`] = b.productType
          a[`addonProduct${i + 1}Price`] = b.priceIncVat.valueWithDecimals
          return a
        },
        {} as ECommerceItem,
      ),
    }
  })
}

export const trackCheckoutStep1 = (
  profileSlug: string,
  productSlug: string | string[],
  profileProduct: FullPublicProfileProductFragment,
): void => {
  pushToDataLayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: '1' },
      },
      products: [
        {
          name: `${profileSlug} - ${productSlug}`,
          id: profileProduct?.id,
          price: profileProduct?.price?.valueWithDecimals,
          category: profileProduct?.product?.productType,
          quantity: 1,
        },
      ],
    },
  })
}

export const trackCheckoutStep2 = (): void => {
  pushToDataLayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: '2' },
      },
    },
  })
}

export const trackCheckoutStep3 = (
  items: GetOrderQuery['market']['order']['items'],
): void => {
  pushToDataLayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: '3' },
      },
      products: getEcommerceProducts(items),
    },
  })
}

export const trackCheckoutStep4 = (): void => {
  pushToDataLayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: '4' },
      },
    },
  })
}

export const trackCheckoutStep5 = (): void => {
  pushToDataLayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: '5' },
      },
    },
  })
}

export const trackCheckoutStep6 = (
  option: string,
  actionFields?: {
    didUseStoredPaymentMethod?: boolean
    didCheckStorePaymentMethod?: boolean
  },
): void => {
  pushToDataLayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: '6', option, ...actionFields },
      },
    },
  })
}
